export const speak = (name: string, rate: number) => {
  const synth = window.speechSynthesis;
  const voice = new SpeechSynthesisUtterance(name);
  voice.lang = "pt-PT";
  voice.pitch = 1;
  voice.rate = rate;
  synth.speak(voice);
};
